'use client';

import type { Point, Side } from './types';

/**
 * @description Returns the side of a rectangle that is closest to a point.
 */
export function getExitSideFromRectangle(point: Point, rect: DOMRect): Side {
  // calculate the absolute distances from the point to each side of the rectangle:
  const top = Math.abs(rect.top - point.y);
  const bottom = Math.abs(rect.bottom - point.y);
  const right = Math.abs(rect.right - point.x);
  const left = Math.abs(rect.left - point.x);

  // determine which of these distances is the shortest
  switch (Math.min(top, bottom, right, left)) {
    case left:
      return 'left';
    case right:
      return 'right';
    case top:
      return 'top';
    case bottom:
      return 'bottom';
    default:
      throw new Error('unreachable');
  }
}
